// Long-form SEO content (German) for each landing page slug.
// Plain content - rendered as semantic <section><h2>/<p>/<ul> in SeoPage.

export const SEO_CONTENT = {
  pendelkostenrechner: {
    sections: [
      {
        h: 'Was kostet Pendeln in Deutschland wirklich?',
        p: 'Die meisten Pendler unterschätzen ihre tatsächlichen Kosten massiv. Der Grund: Sie rechnen nur den Sprit — und vergessen Verschleiß, Wertverlust, Versicherungsanteil und vor allem die eigene Lebenszeit. Wer 25 km pendelt und an 4 Tagen pro Woche ins Büro fährt, kommt schnell auf 3.500 bis 4.500 € echte Kosten pro Jahr — bei nur 1.800 € reinen Spritausgaben. Unser Rechner zeigt dir den ehrlichen Betrag in 30 Sekunden.',
      },
      {
        h: 'Welche Kostenfaktoren stecken im Pendeln?',
        list: [
          'Kraftstoffkosten (variabel nach Sprittyp, Region, Fahrstil)',
          'Verschleiß (Reifen, Bremsen, Öl, Inspektionen) — ca. 0,06–0,10 €/km',
          'Wertverlust des Fahrzeugs — ca. 0,04–0,08 €/km bei Pendlerprofil',
          'Anteilige Versicherung & Steuer (höhere Klasse bei höherer km-Leistung)',
          'Parkgebühren am Arbeitsort (in Städten oft 50–200 €/Monat)',
          'Lebenszeit — nicht monetär, aber der größte Hidden Cost',
        ],
      },
      {
        h: 'Wie berechnet PendelPilot deine Kosten?',
        p: 'Wir verwenden für Verschleiß und Wertverlust einen konservativen Pauschal-Ansatz von 0,12 €/km (Mittelwert aller deutschen Mittelklassen-PKW laut ADAC-Vollkostenrechner). Der Spritpreis kommt entweder live aus deiner PLZ (über die Tankerkönig-Schnittstelle) oder als bundesweiter Durchschnitt. Multipliziert mit deinem Verbrauch und 46 effektiven Arbeitswochen pro Jahr ergibt sich der Jahreswert. Du kannst jeden Wert manuell anpassen — wir blenden nichts aus, was du wissen solltest.',
      },
    ],
  },
  'fahrtkostenrechner-arbeit': {
    sections: [
      {
        h: 'Fahrtkosten zur Arbeit: Was wirklich zählt',
        p: 'Wer die Fahrtkosten zur Arbeit nur als Spritausgabe betrachtet, übersieht 50–60% der tatsächlichen Belastung. Realistische Fahrtkosten enthalten Verschleiß, Wertverlust, anteilige Versicherung und Steuer. Bei einem typischen Pendler mit 30 km Strecke und 4 Bürotagen sind das schnell 4.500–5.500 € pro Jahr — Geld, das oft an anderer Stelle fehlt.',
      },
      {
        h: 'Steuerlich absetzbar: die Pendlerpauschale',
        p: 'Du kannst pro Entfernungs-Kilometer pauschal 0,30 € (bis 20 km) bzw. 0,38 € (ab km 21) als Werbungskosten geltend machen. Bei 30 km Pendelstrecke und 220 Arbeitstagen sind das ca. 1.640 € pro Jahr — die deinen zu versteuernden Bruttobetrag senken. Achtung: Es ist nicht die direkte Steuerersparnis — der tatsächliche Nutzen hängt von deinem Grenzsteuersatz ab (typischerweise 25–40%).',
      },
      {
        h: 'Wann lohnt sich der Wechsel auf ÖPNV oder Bahn?',
        list: [
          'Bei Strecken über 25 km und gleichzeitig guter Bahnverbindung',
          'Wenn die Fahrzeit per ÖPNV nicht mehr als 30% länger ist als per Auto',
          'Wenn du am Arbeitsort hohe Parkgebühren oder Parkplatznot hast',
          'Bei flexibler Arbeitszeit (du kannst die Bahnzeit produktiv nutzen)',
        ],
      },
    ],
  },
  'jobwechsel-rechner': {
    sections: [
      {
        h: 'Lohnt sich der Jobwechsel wirklich?',
        p: 'Ein neues Jobangebot mit 300 € mehr Brutto sieht verlockend aus — bis du den längeren Arbeitsweg gegenrechnest. Wer von 10 km auf 40 km wechselt, gibt schnell 250–350 € pro Monat zusätzlich für Pendelkosten aus. Dazu kommen 30–60 Minuten mehr Wegzeit pro Tag. Der Rechner oben zeigt dir den ehrlichen Netto-Vorteil pro Monat.',
      },
      {
        h: 'Was du beim Jobwechsel sonst beachten solltest',
        list: [
          'Brutto-Netto: 300 € mehr Brutto = oft nur 170–200 € mehr Netto',
          'Pendelkosten steigen überproportional mit der Distanz (Verschleiß!)',
          'Lebenszeit: 1 h täglich mehr = 230 h pro Jahr = fast 6 Arbeitswochen',
          'Homeoffice-Anteil verhandeln — der größte versteckte Vorteilshebel',
          'Probearbeit oder Praxistag um die echte Belastung zu spüren',
        ],
      },
    ],
  },
  'arbeitsweg-kosten-berechnen': {
    sections: [
      {
        h: 'So berechnest du deine Arbeitsweg-Kosten ehrlich',
        p: 'Die ADAC-Vollkostenrechnung ist die solideste Quelle für deutsche PKW-Betriebskosten. Sie umfasst Kraftstoff, Wartung, Reifenverschleiß, Wertverlust, Versicherung und Steuer. Für einen typischen Pendler-PKW (VW Golf, BMW 1er, Skoda Octavia & co.) liegt der Vollkostensatz aktuell zwischen 0,38 und 0,52 € pro Kilometer. PendelPilot rechnet konservativ mit dem unteren Bereich, damit deine Schätzung realistisch bleibt.',
      },
      {
        h: 'Stunden im Auto sind verlorene Lebenszeit',
        p: 'Ein Pendler mit 30 km Strecke verbringt rund 230 Stunden pro Jahr im Auto — das entspricht 9,5 Arbeitstagen oder fast 2 Wochen Urlaub. Diese Zeit ist weder Freizeit noch produktive Arbeitszeit. Studien (z.B. Eurofound 2022) zeigen einen klaren Zusammenhang zwischen Pendel-Dauer und sinkender Lebenszufriedenheit ab ca. 45 Minuten pro Strecke.',
      },
    ],
  },
  'auto-finanzieren-rechner': {
    sections: [
      {
        h: 'Pendel-Auto finanzieren: Vorsicht vor versteckten Kosten',
        p: 'Bevor du ein Auto auf Kredit oder per Leasing finanzierst, lohnt sich die ehrliche Vollkostenrechnung. Die Monatsrate ist nur ein Teil — Sprit, Verschleiß, Versicherung und Wertverlust verdoppeln die monatliche Belastung oft. Wer 350 € Leasingrate zahlt und 30 km pendelt, kommt schnell auf 700–800 € echte Monatskosten.',
      },
      {
        h: 'Faustregeln für Pendler-Finanzierung',
        list: [
          'Gesamtkosten (Rate + Betrieb) sollten unter 15% des Netto-Haushaltseinkommens liegen',
          'Bei >25.000 km pro Jahr: Leasing-Mehrkilometer-Klausel prüfen — kann teuer werden',
          'Diesel rechnet sich erst ab ca. 20.000 km/Jahr — sonst nimm Benziner oder E-Auto',
          'E-Auto wird ab 15.000 km/Jahr finanziell interessant (Steuer + Spritersparnis)',
        ],
      },
    ],
  },
  'pendeln-kosten-pro-monat': {
    sections: [
      {
        h: 'Pendeln pro Monat: typische Kostenbeispiele',
        p: 'Damit du eine realistische Vorstellung bekommst, hier drei typische Pendlerprofile (4 Bürotage/Woche, mittlerer Verbrauch, Durchschnittsspritpreis):',
        list: [
          'Kurzstrecke (10 km einfach): ca. 130–180 € pro Monat',
          'Mittelstrecke (25 km einfach): ca. 280–380 € pro Monat',
          'Langstrecke (50 km einfach): ca. 550–750 € pro Monat',
        ],
      },
      {
        h: 'Warum Pendelkosten oft unterschätzt werden',
        p: 'Klassischer Denkfehler: "Ich rechne nur den Sprit." Aber dein Auto verschleißt mit jeder Fahrt — und je länger die Pendelstrecke, desto schneller verlierst du Wert beim Wiederverkauf. ADAC-Berechnungen zeigen: Bei 25.000 km Pendlerprofil sind die "unsichtbaren" Kosten (Verschleiß + Wertverlust + Versicherungsklasse) oft höher als die reinen Spritkosten.',
      },
    ],
  },
  'homeoffice-rechner': {
    sections: [
      {
        h: 'Was bringt Homeoffice finanziell wirklich?',
        p: 'Jeder Homeoffice-Tag spart dir die Pendelkosten dieses Tages — aber auch Zeit, Stress und Verschleiß. Bei 25 km Strecke und 4 Bürotagen entspricht 1 Tag Homeoffice/Woche etwa 700–900 € Ersparnis pro Jahr plus 50–70 Stunden Lebenszeit. Bei 2 Tagen sind es bereits 1.400–1.800 € — Geld, das in vielen Haushalten den Unterschied macht.',
      },
      {
        h: 'Argumente für Homeoffice-Verhandlung mit dem Arbeitgeber',
        list: [
          'Du sparst nicht nur Geld, sondern bist meist produktiver an reinen Konzentrations-Tagen',
          'Geringere Krankheitstage (weniger Pendel-Stress, weniger Erkältungen)',
          'Du nutzt deine Lebenszeit für Familie, Sport oder Erholung',
          'Dein CO₂-Fußabdruck sinkt deutlich — relevantes Argument bei Nachhaltigkeits-Themen',
        ],
      },
      {
        h: 'Steuerliche Vorteile vom Homeoffice (2025)',
        p: 'Du kannst pauschal 6 € pro Homeoffice-Tag (max. 1.260 € im Jahr für 210 Tage) als Werbungskosten ansetzen — auch ohne separates Arbeitszimmer. Die Pendlerpauschale fällt an Homeoffice-Tagen weg, aber netto bleibt der Vorteil für viele Pendler deutlich positiv.',
      },
    ],
  },
  'pendlerpauschale-rechner': {
    sections: [
      {
        h: 'Pendlerpauschale 2025: die wichtigsten Regeln',
        list: [
          '0,30 € pro Entfernungskilometer für die ersten 20 km',
          '0,38 € pro Entfernungskilometer ab dem 21. Kilometer',
          'Nur einfache Strecke zählt (nicht Hin- und Rückfahrt)',
          'Pro Arbeitstag wird ein voller Weg gerechnet — auch wenn du mehrfach fährst',
          'Maximal 4.500 € pro Jahr ohne Nachweis (außer eigenes Auto/höhere Kosten belegbar)',
        ],
      },
      {
        h: 'Wichtig: Pauschale ≠ Steuerersparnis',
        p: 'Die Pendlerpauschale reduziert dein zu versteuerndes Einkommen — nicht direkt deine Steuer. Bei 1.500 € Pauschale und einem Grenzsteuersatz von 30% beträgt deine tatsächliche Steuerersparnis ca. 450 € pro Jahr. Trotzdem ein klarer Vorteil, den jeder Pendler nutzen sollte.',
      },
      {
        h: 'Kürzeste vs. günstigste Strecke',
        p: 'Maßgeblich ist grundsätzlich die kürzeste Straßenverbindung zwischen Wohnung und erster Tätigkeitsstätte. Du darfst nur dann eine längere Strecke ansetzen, wenn sie offensichtlich verkehrsgünstiger ist (z.B. Autobahn statt Stadtstrecke mit vielen Ampeln) — und du dies plausibel begründen kannst.',
      },
    ],
  },
};
